import _ from 'lodash';
import { useMemo } from 'react';
import {  SelectInput, SelectInputProps, useGetOne, useRecordContext } from "react-admin"

interface Props extends SelectInputProps {
    pre?: { id: any, name: string }[],
    localePath?: string,
}
export function ProfileSelectInput({ pre = [], ...props }: Props) {

    const { data } = useGetOne('locale', { id: "en" }, { staleTime: Infinity, gcTime: Infinity });
    const record = useRecordContext(props);
    const { source, localePath, ...other } = props;
    const field = localePath || source!.split('.')[1];

    const choices = useMemo(() => {
        if (data) {
            const section = data[field];
            if (record?.profile?.role) {

                const role = record.profile.role;
                const subsection = section.default || section[role];
                return subsection?.options.map(({ _id, text }: any) => ({ id: _id, name: text })) || [];
            } else {

                const mergeSectionOptions = (section$: any) => {
                    const ids = _.chain(section$).values()
                        .filter(({ options }) => options?.length > 0)
                        .flatMap(({ options }) => options.map(({ _id }: { _id: string }) => _id))
                        .uniq()
                        .map(id => ({ id, name: `${id}` }))
                        .value()
                    return ids;
                }
                const defaultSectionOptions = (section$: any) => {
                    const options = section$.default?.options?.map(({ _id, text }: { _id: string, text: string }) => ({ id: _id, name: text }))
                    return options
                }
                const options = defaultSectionOptions(section) || mergeSectionOptions(section)
                return options
            }
        }
    }, [data, record, field])

    return (
        <SelectInput
            isPending={!choices}
            
            variant="outlined"
            choices={choices && [...pre, ...choices]}
            source={source}
            {...other}
            optionValue={"id"}
            optionText="name"
        />
    )
}